// The avatar of the TV user lives in the new API (GET, POST and DELETE /api/tv/avatar, the user's api key is the Bearer token);
// VUE_APP_AVATAR_API_URL overrides the address completely (for example a local test host).
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || "https://n4-l-rest-v1.norma4.ks.ua/api";

export default {
    AVATAR: process.env.VUE_APP_AVATAR_API_URL || `${API_BASE_URL}/tv/avatar`,
};
